import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class ContratoModel extends EntidadeBase {
  constructor() {
    super('contrato');
  }

  async provisionar(id) {
    return ApiService.post('/contrato/provisionar', { id });
  }

  async consultarCnpj(cnpj) {
    return ApiService.post('/contrato/consultarcnpj', { cnpj });
  }

  async trocarModalidade(id, modalidade) {
    return ApiService.post('/contrato/trocarmodalidade', { id, modalidade });
  }
}

export default new ContratoModel();
